import React from "react"
import { forwardRef } from "react"
import styled from "styled-components"
import concatWithSpaces from "../Functions/concatWithSpaces"

interface Props extends React.ComponentProps<"div"> {
	small?: boolean
	isSelected?: boolean
	optionButtons?: boolean
}

const DropdownButton = forwardRef<HTMLDivElement, Props>(
	({ small, style, isSelected, optionButtons, className, ...props }, ref) => {
		const classNameSwitch = () => {
			return `  pointer non-draggable ${
				optionButtons ? "center-y-start " : "center-x-y "
			}`
		}
		return (
			<Base
				{...props}
				className={concatWithSpaces(
					classNameSwitch(),
					"pointer non-draggable ",
					className
				)}
				style={{
					fontSize: small ? 16 : undefined,
					...style,
				}}
				ref={ref}
			/>
		)
	}
)

export default DropdownButton

const Base = styled.div`
	font-size: 18px;
	font-weight: bold;
	line-height: 21px;
	text-transform: uppercase;
	text-align: center;
	padding: 0.7em 0.95em;
	box-sizing: border-box;

	// Animation
	transition: 0.2s var(--default-slide-transition-fn);
	transition-property: background-color, color;

	:hover {
		background-color: var(--main-color-bg);
		color: var(--white);
	}
`
